import { render, staticRenderFns } from "./HospitalDispatcher.vue?vue&type=template&id=46ef2ec8&scoped=true&"
import script from "./HospitalDispatcher.vue?vue&type=script&lang=js&"
export * from "./HospitalDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./HospitalDispatcher.vue?vue&type=style&index=0&id=46ef2ec8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef2ec8",
  null
  
)

export default component.exports